import { render, staticRenderFns } from "./Screen3.vue?vue&type=template&id=25246a22&"
import script from "./Screen3.vue?vue&type=script&lang=js&"
export * from "./Screen3.vue?vue&type=script&lang=js&"
import style0 from "./Screen3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports